module.exports = __webpack_public_path__ + "../resources/img/ic_re_thunder_solid.fd2646c1.svg";